import PageModule from "@eisinc/Overrides/Pages/ProductListPage";

export * from "@eisinc/Overrides/Pages/ProductListPage";

export default PageModule;
